import { Button, Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import DatePickerStyled from "../DatePickerStyled";
import { LocationSelector } from "../LocationSelector";
import TextFieldStyled from "../TextFieldStyled";
import TimeSelector from "../TimeSelector";
import { ZipcodeSelector } from "../ZipcodeSelector";

const EventForm = ({ bandProfile, event, onChange }) => {
  const DEFAULT_VALUES = { usergenerated: true, bands: [bandProfile?.id] };
  const [zipcode, setZipcode] = useState(event?.zipcode);
  const [formValues, setFormValues] = useState(event ?? DEFAULT_VALUES);

  const handleInputChanged = (event, value) => {
    const { name, value: valueFromEvent } = event.target;
    setFormValues({ ...formValues, [name]: value ?? valueFromEvent });

    if (name === "zipcode") {
      setZipcode(valueFromEvent);
    }
  };

  const handleDateChanged = (name, value) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const handleTimeChanged = (value) => {
    const datetime = new Date("1970-01-01T" + value + "Z");
    setFormValues({ ...formValues, time_start: datetime });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setFormValues(DEFAULT_VALUES);
    if (onChange) {
      onChange(formValues);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container columnSpacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          <DatePickerStyled
            name="date_start"
            value={
              (typeof formValues.date_start === "string"
                ? new Date(formValues.date_start)
                : formValues.date_start) ?? null
            }
            label="Datum *"
            band={bandProfile}
            onChange={(value) => {
              handleDateChanged("date_start", value);
            }}
            required={true}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <DatePickerStyled
            name="date_end"
            value={
              (typeof formValues.date_end === "string"
                ? new Date(formValues.date_end)
                : formValues.date_end) ?? null
            }
            label="Datum Ende"
            band={bandProfile}
            helpertext="Bei mehrtägigen Events"
            onChange={(value) => {
              handleDateChanged("date_end", value);
            }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TimeSelector
            label="Uhrzeit"
            onChange={handleTimeChanged}
            value={formValues.time_start || null}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <ZipcodeSelector
            name="zipcode"
            label="Stadt"
            required={true}
            onChange={handleInputChanged}
            defaultValue={formValues.zipcode ?? null}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <LocationSelector
            onChange={handleInputChanged}
            name="location"
            label="Club / Venue / Bühne"
            zipcodeId={
              zipcode
                ? typeof zipcode === "object"
                  ? zipcode.id
                  : zipcode
                : null
            }
            defaultValue={formValues.location ?? null}
            disabeld={!zipcode}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextFieldStyled
            name="name"
            label="Name"
            required={true}
            value={formValues.name || ""}
            placeholder="…"
            helpertext="z.B. Festivalname"
            onChange={handleInputChanged}
          />
        </Grid>

        <Grid item xs={12}>
          <TextFieldStyled
            name="link"
            type="text"
            label="Link zu weiteren Infos"
            value={formValues.link || ""}
            placeholder="…"
            onChange={handleInputChanged}
          />
        </Grid>

        <Grid item xs={12} sm="auto" sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="secondary">
            Konzert speichern
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

EventForm.propTypes = {
  bandProfile: PropTypes.object.isRequired,
};

export default EventForm;
